import { CreatePrestitoLeadCommand } from '../../../../services/api/acquisition/prestitoAcquisition';
import type { AcquisitionReviewSection } from '../AcquisitionConfirmDialog';
import { acquisitionEuro } from '../acquisitionAmount';
import { acquisitionLocationLabel } from '../acquisitionCustomer';
import { prestitoYesNoLabel } from './prestitoOptions';

export const PRESTITO_REVIEW_TITLE = 'Conferma acquisizione lead Prestito';

/**
 * What confirming sets in motion. It stops at the point the backend's success
 * boundary stops: the credential email is asynchronous and best effort, so the
 * copy says the sending starts, never that the customer received anything.
 */
export const PRESTITO_REVIEW_NOTICE =
  'Confermando, la lead entra in Programma Tasso come Lead in gestione e viene creato il relativo Deal. Se il cliente non ha ancora un Account Area Clienti viene creato e ne viene avviato l’invio delle credenziali. L’operazione non è annullabile.';

/**
 * The read-only review of one compiled Prestito draft. It reads the command
 * confirmation will send, not the form behind it, so what the operator
 * approves and what leaves the browser cannot drift apart. Only the operator's
 * own answers appear: the acquisition origin, the owner, the actor and the
 * idempotency key of the submission are server-owned or header-only, and a
 * field whose branch does not apply is absent from both the command and here.
 */
export const prestitoReviewSections = (
  command: CreatePrestitoLeadCommand
): AcquisitionReviewSection[] => [
  {
    title: 'Richiesta',
    fields: [
      { label: 'Importo richiesto', value: acquisitionEuro(command.loanAmount) },
      { label: 'Finalità del prestito', value: command.loanPurpose },
    ],
  },
  {
    title: 'Situazione lavorativa e requisiti',
    fields: [
      { label: 'Contratto di lavoro', value: command.employmentContract },
      ...(command.yearsTaxNumber
        ? [
            {
              label: 'Anni di attività con partita IVA',
              value: command.yearsTaxNumber,
            },
          ]
        : []),
      ...(command.hasGuarantor
        ? [
            {
              label: 'Garante',
              value: prestitoYesNoLabel(command.hasGuarantor),
            },
          ]
        : []),
      ...(command.yearsCurrentCompany
        ? [
            {
              label: 'Anni nell’azienda attuale',
              value: command.yearsCurrentCompany,
            },
          ]
        : []),
      ...(command.monthlyIncome !== undefined
        ? [
            {
              label: 'Reddito mensile',
              value: acquisitionEuro(command.monthlyIncome),
            },
          ]
        : []),
      ...(command.monthlyIncomePensioner !== undefined
        ? [
            {
              label: 'Pensione mensile',
              value: acquisitionEuro(command.monthlyIncomePensioner),
            },
          ]
        : []),
      {
        label: 'Ha mai avuto altri finanziamenti?',
        value: prestitoYesNoLabel(command.hasOtherFinancing),
      },
      ...(command.hasLatePreviousLoan
        ? [
            {
              label: 'Ritardi nei pagamenti',
              value: prestitoYesNoLabel(command.hasLatePreviousLoan),
            },
          ]
        : []),
      ...(command.employeesNumber
        ? [
            {
              label: 'Dipendenti dell’azienda',
              value: command.employeesNumber,
            },
          ]
        : []),
    ],
  },
  {
    title: 'Residenza',
    fields: [
      { label: 'Località', value: acquisitionLocationLabel(command.location) },
    ],
  },
  {
    title: 'Cliente',
    fields: [
      { label: 'Nome', value: command.firstName },
      { label: 'Cognome', value: command.lastName },
      { label: 'Email', value: command.email },
      {
        label: 'Telefono',
        value: `${command.phonePrefix} ${command.phone}`,
      },
    ],
  },
];
